// extracted by mini-css-extract-plugin
export default {"section":"Section_section__FXOh6","section--manifest":"Section_section--manifest__4YZtD","section--gray":"Section_section--gray__LVO2J"};